export default __webpack_public_path__ + "static/media/Avatar-17-noback.f1852b40.png";